import { FAVORITE_LIST_TYPE_LABEL } from './constants'


export const getFavoriteListType = (favorite_list) => {
  return FAVORITE_LIST_TYPE_LABEL[favorite_list.access_type] || null;
};